import {
  useFormErrorNotification,
  useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { $api } from "../generated/client";
import { useInvalidateCarriersQuery } from "./use-carriers-query";
import {useMutation} from "@tanstack/react-query";
import {CreateCarrierDto} from "../generated/schema.ts";

export function useAddCarrier(shopId: string) {
  const successNotification = useFormSuccessNotification();
  const errorNotification = useFormErrorNotification();
  const invalidateShop = useInvalidateCarriersQuery({ shopId });

  const mutation = $api.useMutation("post", "/shops/{shopId}/carriers");

  return useMutation({
    onSuccess: () => {
      invalidateShop();
      successNotification();
    },
    onError: () => {
      errorNotification();
    },
    mutationFn: (data: CreateCarrierDto) => mutation.mutateAsync({ body: data, params: { path: { shopId } } }),
  });
}
